module.exports = __webpack_public_path__ + "static/media/apple-icon.9838ea6b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/apple-icon.svg
// module id = ./src/images/apple-icon.svg
// module chunks = 0